import { BaseDto } from './base.dto';
import { BundleProductDto } from './bundleProduct.dto';
import { ProductDto } from './product.dto';

export class BundleCombinationDto extends BaseDto {
  bundleCombination?: ProductDto;
  products?: BundleProductDto[];
}
